import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FirstButton from "../common/button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  filters,
  // searchResult,
  about,
} from "../data/SupplierData";
import Rating from "@mui/material/Rating";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AccordionDetails from "@mui/material/AccordionDetails";
import { TextField, Card, CircularProgress } from "@mui/material";
import BreadCrumbs from "./BreadCrumbs";
import { Tabs } from "@mui/material";
import Tab from "@mui/material/Tab";
import Dropdown from "../common/dropdown";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import api from "../Axios";
import Pagination from "@mui/material/Pagination";
import noData from "../assets/images/noData.png";
import supp1 from "../assets/images/supplier/parm01.jpg";
import supp2 from "../assets/images/supplier/parm02.jpg";
import supp3 from "../assets/images/supplier/parm03.jpg";
import supp4 from "../assets/images/supplier/parm04.jpg";
import supp5 from "../assets/images/supplier/parm05.jpg";
import supp6 from "../assets/images/supplier/parm06.jpg";
import emergPlay from "../assets/images/Emerging Player.png";
import SupervisedUserCircleRoundedIcon from "@mui/icons-material/SupervisedUserCircleRounded";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import StarsIcon from "@mui/icons-material/Stars";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useFormContext } from "../router/FormContext";
const SupplierSearchPage = () => {
  const supplierData = [
    { name: "USFDA GMP manufacturers", img: supp1 },
    { name: "EU GMP MANUFACTURERS", img: supp2 },
    { name: "INJECTABLE CDMO", img: supp3 },
    { name: "SOFT GEL CDMO", img: supp4 },
    { name: "BIOSIMILARS", img: supp5 },
    { name: "ONCOLOGY", img: supp6 },
  ];
  const navigate = useNavigate();
  const [searchTerms, setSearchTerms] = useState({});
  const [searchResult, setSearchResult] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  // const [search, setSupSearch] = useState("");
  const [count, setCount] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const initialSupplierState = {
    ManufacturingPlantLocation: [],
    DosageForms: [],
    cGMPAccreditation: [],
    Specialcapabilities: [],
    ManufacturerType: [],
    operation: {
      fiveless: false,
      sixtoten: false,
      tentotwenty: false,
      Twentymore: false,
    },
  };

  // const [supplierFormState, setSupplierFormState] =
  //   useState(initialSupplierState);
  const { supplierFormState, setSupplierFormState } = useFormContext();
  const { supsearch, setSupSearch } = useFormContext();
  const [checkformState, setCheckFormState] = useState(initialSupplierState);
  const urls = [
    { name: "Home", url: "/home" },
    { name: "Supplier Search", url: "" },
  ];
  const [value, setValue] = useState("2");
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
    searchSupplier(supplierFormState, "");
  }, []);

  const getSupplier = (page, search) => {
    setIsLoading(true);
    const data = {
      page: page,
      limit: 3,
      searchChar: search,
    };
    api
      .post("get-supplier", data)
      .then((resp) => {
        setSearchResult(resp?.data?.data);
        const totalObjects = resp?.data?.totalcount;
        setCount(totalObjects);
        const totalPages = Math.ceil(totalObjects / 3);
        setTotalPage(totalPages);
        setPage(page);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChange = (event, newValue) => {
    if (newValue === "1") {
      navigate("/dossier-search");
    } else if (newValue === "2") {
      navigate("/supplier-search");
    }
    setValue(newValue);
  };
  const handleSearchChange = (filterId, e) => {
    setSearchTerms({
      ...searchTerms,
      [filterId]: e.target.value.toLowerCase(),
    });
  };

  const handleOperationChange = (itemSub) => {
    const key = mapOperationKey(itemSub);

    const updatedOperation = {
      fiveless: false,
      sixtoten: false,
      tentotwenty: false,
      Twentymore: false,
      [key]: true, // Set the selected one to true
    };

    const updatedState = {
      ...supplierFormState,
      operation: updatedOperation,
    };

    setSupplierFormState(updatedState);
    searchSupplier(updatedState);
  };

  const normalizeKey = (category) => {
    return `${category}`
      .replace(/[\s-,]/g, "")
      .replace(/\((.*?)\)/g, "$1")
      .replace(/\//g, "");
  };

  const handleCheckboxChange = (categoryName, filterValue, checked) => {
    const normalizedCategory = normalizeKey(categoryName);
    let updatedState = { ...supplierFormState };
    if (normalizedCategory === "Yearsofoperation") {
      const operationKey = {
        "<5": "fiveless",
        "6-10": "sixtoten",
        "10-20": "tentotwenty",
        "20+": "Twentymore",
      }[filterValue];

      if (operationKey) {
        updatedState.operation = {
          ...supplierFormState.operation,
          [operationKey]: checked,
        };
      }
    } else {
      const categoryKey = Object.keys(initialSupplierState).find(
        (key) => normalizeKey(key) === normalizedCategory,
      );

      if (categoryKey) {
        const currentArray = supplierFormState[categoryKey] || [];
        const updatedArray = checked
          ? [...currentArray, filterValue]
          : currentArray.filter((val) => val !== filterValue);

        updatedState[categoryKey] = updatedArray;
      }
    }

    setSupplierFormState(updatedState);
    searchSupplier(updatedState); // Call your search logic
  };

  const searchSupplier = (updatedState, pageNo, searchData) => {
    setIsLoading(true);
    const data = {
      page:
        pageNo === "" || pageNo === null || pageNo === undefined ? 1 : pageNo,
      limit: 3,
      searchChar: searchData !== undefined ? searchData : supsearch,
      SuListing_Filter_manufacturer_type: updatedState?.ManufacturerType,
      SuListing_Filter_Detailed_Dosageform: updatedState?.DosageForms,
      SuListing_Filter_Special_capabilities: updatedState?.Specialcapabilities,
      SuListing_Search_Manufacturing_Plant_location:
        updatedState?.ManufacturingPlantLocation,
      Sulisting_Filter_cGMP_accreditation: updatedState?.cGMPAccreditation,
      operation: updatedState?.operation,
    };

    api
      .post("search-supplier", data)
      .then((resp) => {
        setSearchResult(resp?.data?.data);
        const totalObjects = resp?.data?.count;
        setCount(totalObjects);
        const totalPages = Math.ceil(totalObjects / 3);
        setTotalPage(totalPages);
        if (pageNo === "" || pageNo === null || pageNo === undefined) {
          setPage(1);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handlePageChange = (event, value) => {
    setPage(value);
    if (supplierFormState === checkformState) {
      getSupplier(value, supsearch);
    } else {
      searchSupplier(supplierFormState, value);
    }
  };
  const resetState = () => {
    setSupplierFormState(initialSupplierState);
    setCheckFormState(initialSupplierState);
    searchSupplier(initialSupplierState, page, "");
  };

  const handleRemoveArrayFilter = (category, value) => {
    const updatedState = {
      ...supplierFormState,
      [category]: supplierFormState[category].filter((item) => item !== value),
    };

    setSupplierFormState(updatedState);
    searchSupplier(updatedState);
  };
  const mapOperationKey = (value) => {
    switch (value) {
      case "<5":
        return "fiveless";
      case "6-10":
        return "sixtoten";
      case "10-20":
        return "tentotwenty";
      case "20+":
        return "Twentymore";
      default:
        return "";
    }
  };

  const handleCardClick = (name) => {
    let value = "";
    let key = "";

    switch (name) {
      case "USFDA GMP manufacturers":
        value = "USFDA";
        key = "cGMPAccreditation";
        break;
      case "EU GMP MANUFACTURERS":
        value = "EU GMP";
        key = "cGMPAccreditation";
        break;
      case "INJECTABLE CDMO":
        value = "Injectable";
        key = "DosageForms";
        break;
      case "SOFT GEL CDMO":
        value = "Soft gel capsules";
        key = "DosageForms";
        break;
      case "BIOSIMILARS":
        value = "Biologics & Biosimilars";
        key = "Specialcapabilities";
        break;
      case "ONCOLOGY":
        value = "Oncology";
        key = "Specialcapabilities";
        break;
      default:
        return;
    }

    setSupplierFormState((prevState) => {
      const clearedState = {
        ...prevState,
        ManufacturingPlantLocation: [],
        DosageForms: [],
        cGMPAccreditation: [],
        Specialcapabilities: [],
        ManufacturerType: [],
        // operation stays the same
      };

      const updatedArray = [value];

      const updatedState = {
        ...clearedState,
        [key]: updatedArray,
      };

      // Trigger search with updated state
      searchSupplier(updatedState);

      return updatedState;
    });
  };

  return (
    <div className="search backgroundColor">
      <BreadCrumbs array={urls} />
      <div className="only-d-flex justify-center align-center mt-3">
        <Tabs
          value={value}
          onChange={handleChange}
          className="w30 "
          sx={{
            "& button": { borderRadius: 2 },
            "& button:hover": {
              backgroundColor: "#7915cf",
              color: "white",
              opacity: 0.55,
            },
            "& button:focus": {
              backgroundColor: "#7915cf",
              color: "white",
            },
            "& button:active": {
              backgroundColor: "#7915cf",
              color: "white",
            },
            "& .MuiTabs-indicator": {
              display: "none", // Hide the indicator line
            },
          }}
        >
          <Tab
            className={
              value === "1" ? "fs-14 fw-600  activeTab" : "fs-14 fw-600 "
            }
            value="1"
            label="Dossier Finder"
          />
          <Tab
            className={
              value === "2" ? "fs-14 fw-600  activeTab" : "fs-14 fw-600 "
            }
            value="2"
            label="Supplier Finder  "
          />
        </Tabs>
      </div>
      <div className="searchInput">
        <input
          className="login_input bg-white"
          placeholder="Search"
          style={{ width: "60%" }}
          value={supsearch}
          onChange={(e) => {
            const value = e.target.value;
            setSupSearch(value);
            if (value.length === 0) {
              searchSupplier(supplierFormState, "", "");
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              // handleSubmit();
              searchSupplier(supplierFormState, "");
            }
          }}
        />

        <FirstButton
          buttonText={isLoading ? "Searching..." : "Submit"}
          onClick={(e) => {
            if (!isLoading) {
              searchSupplier(supplierFormState, "");
            }
          }}
          className={isLoading ? "btn-gray ms-3" : "btn ms-3"}
          disabled={isLoading}
        />
      </div>
      <div className="ph-spcardmain2 bg-white">
        <div className="row  ">
          {supplierData &&
            supplierData.map((item, index) => (
              <div className="col-md-2 p-0">
                <Card
                  className="p-2 mx-2 text-center mb-2 supplier-filter-card"
                  onClick={() => handleCardClick(item.name)}
                >
                  <img
                    src={item?.img}
                    style={{ width: "35%" }}
                    className="mb-2"
                  />
                  <p className="fs-14 fw-600 text-center two-line-text">
                    {item?.name}
                  </p>
                </Card>
              </div>
            ))}
        </div>
      </div>
      <div className="dflex ">
        <div className="w20">
          <div className="dflex">
            <div className="mb-3 dflex">
              <FirstButton
                buttonText="Reset"
                onClick={resetState}
                className={
                  supplierFormState === checkformState
                    ? "btn-gray ms-2"
                    : "btn ms-2"
                }
              />
            </div>

            <h2 className="main_imgcont2 fs-20 fw-600 my-2">Filters</h2>
          </div>
        </div>
        <div className="w60">
          <h2 className="main_imgcont2 fs-20 fw-600 my-2 ">
            {isLoading ? "Searching..." : `${count} suppliers found`}
          </h2>
        </div>
      </div>
      <div className="dflex ">
        <div className="w20  m121">
          {filters &&
            filters.map((item, index) => (
              <Accordion key={index} className="accordian-scroll-added">
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <h4>{item.name}</h4>

                    {/* Selected Values Display */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                        marginTop: "5px",
                      }}
                    >
                      {item.id === 1 &&
                        supplierFormState.DosageForms.length > 0 &&
                        supplierFormState.DosageForms.map((value, idx) => (
                          <span key={idx} className="selectedText">
                            {value}
                            <button
                              className="selected-cancel-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveArrayFilter("DosageForms", value);
                              }}
                            >
                              ✖
                            </button>
                          </span>
                        ))}
                      {item.id === 2 &&
                        supplierFormState.cGMPAccreditation.length > 0 &&
                        supplierFormState.cGMPAccreditation.map(
                          (value, idx) => (
                            <span key={idx} className="selectedText">
                              {value}
                              <button
                                className="selected-cancel-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveArrayFilter(
                                    "cGMPAccreditation",
                                    value,
                                  );
                                }}
                              >
                                ✖
                              </button>
                            </span>
                          ),
                        )}
                      {item.id === 4 &&
                        supplierFormState.ManufacturingPlantLocation.length >
                          0 &&
                        supplierFormState.ManufacturingPlantLocation.map(
                          (value, idx) => (
                            <span key={idx} className="selectedText">
                              {value}
                              <button
                                className="selected-cancel-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveArrayFilter(
                                    "ManufacturingPlantLocation",
                                    value,
                                  );
                                }}
                              >
                                ✖
                              </button>
                            </span>
                          ),
                        )}
                      {item.id === 5 &&
                        supplierFormState.Specialcapabilities.length > 0 &&
                        supplierFormState.Specialcapabilities.map(
                          (value, idx) => (
                            <span key={idx} className="selectedText">
                              {value}
                              <button
                                className="selected-cancel-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveArrayFilter(
                                    "Specialcapabilities",
                                    value,
                                  );
                                }}
                              >
                                ✖
                              </button>
                            </span>
                          ),
                        )}
                      {item.id === 6 &&
                        supplierFormState.ManufacturerType.length > 0 &&
                        supplierFormState.ManufacturerType.map((value, idx) => (
                          <span key={idx} className="selectedText">
                            {value}
                            <button
                              className="selected-cancel-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveArrayFilter(
                                  "ManufacturerType",
                                  value,
                                );
                              }}
                            >
                              ✖
                            </button>
                          </span>
                        ))}
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails className="px-3 py-2 text-start">
                  {/* Search Box for the specific checkbox list */}
                  {item.id !== 0 && item?.id !== 3 && (
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Search"
                      fullWidth
                      value={searchTerms[item.id] || ""}
                      onChange={(e) => handleSearchChange(item.id, e)}
                      style={{ marginBottom: "1rem" }}
                    />
                  )}

                  {item.subFilters &&
                    item.subFilters
                      .filter((itemSub) =>
                        itemSub
                          .toLowerCase()
                          .includes(searchTerms[item.id] || ""),
                      )
                      .map((itemSub, subIndex) => (
                        <AccordionDetails className="px-3 py-2" key={subIndex}>
                          <FormControlLabel
                            control={
                              item.id === 7 ? (
                                <input
                                  type="radio"
                                  name="operationYears"
                                  value={itemSub}
                                  className="p-2"
                                  checked={
                                    supplierFormState.operation[
                                      mapOperationKey(itemSub)
                                    ]
                                  }
                                  onChange={() =>
                                    handleOperationChange(itemSub)
                                  }
                                />
                              ) : (
                                <Checkbox
                                  checked={(
                                    supplierFormState[
                                      Object.keys(supplierFormState).find(
                                        (key) =>
                                          key.replace(/[\s(),-]+/g, "") ===
                                          item.name.replace(/[\s(),-]+/g, ""),
                                      )
                                    ] || []
                                  ).includes(itemSub)}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      item.name,
                                      itemSub,
                                      e.target.checked,
                                    )
                                  }
                                  sx={{
                                    color: " #4c8df5",
                                    "&.Mui-checked": { color: "#4c8df5" },
                                    "& .MuiSvgIcon-root": { fontSize: 24 },
                                  }}
                                />
                              )
                            }
                            labelPlacement={item.id === 3 ? "start" : "end"}
                            label={
                              <span
                                style={
                                  item.id === 3 && itemSub === "After"
                                    ? {
                                        fontSize: "1.4rem",
                                        marginRight: "6.2rem",
                                        fontWeight: "400",
                                      }
                                    : item.id === 3
                                      ? {
                                          fontSize: "1.4rem",
                                          marginRight: "5rem",
                                          fontWeight: "400",
                                        }
                                      : {
                                          fontSize: "1.4rem",
                                          marginLeft: "1rem",
                                          fontWeight: "400",
                                        }
                                }
                              >
                                {itemSub}
                              </span>
                            }
                          />
                        </AccordionDetails>
                      ))}
                </AccordionDetails>
              </Accordion>
            ))}
        </div>
        {isLoading ? (
          <div
            className="w60 d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <CircularProgress size={60} sx={{ color: "#7915cf" }} />
          </div>
        ) : count > 0 ? (
          <>
            <div className="w60">
              {searchResult &&
                searchResult.map((sitem, index) => (
                  <div
                    key={sitem?._id}
                    className="ph-spcardmain-supplier bg-white"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/supplier-details/${sitem?._id}`)}
                  >
                    <div className="row ">
                      {/* Supplier Details */}
                      <div className="col-md-4 p-0 w30">
                        <Card className="p-3 mx-2 shadow-none mb-4">
                          <h2 className="fs-24 fw-600 cursor-pointer title-hover text-center">
                            Supplier {sitem?.Plant_ID}
                          </h2>
                          <div className="d-flex justify-content-center mt-2">
                            {(() => {
                              const ratingValue =
                                sitem?.SuListing_Star_Rating || 0;

                              let precision = 1;
                              if (ratingValue % 1 !== 0) {
                                if (ratingValue % 0.25 === 0) precision = 0.25;
                                else if (ratingValue % 0.5 === 0)
                                  precision = 0.5;
                                else precision = 0.1;
                              }

                              return (
                                <Rating
                                  className="icon-style"
                                  name={`read-only-${index}`}
                                  value={ratingValue}
                                  precision={precision}
                                  readOnly
                                />
                              );
                            })()}
                          </div>

                          {sitem?.SuListing_Search_Manufacturing_Plant_location
                            ?.length > 0 && (
                            <p className="location">
                              <span className="mb-1 me-1">
                                <LocationOnIcon
                                  style={{ color: "#6a1ca5", fontSize: "28px" }}
                                />
                              </span>
                              {sitem.SuListing_Search_Manufacturing_Plant_location.join(
                                ", ",
                              )}
                            </p>
                          )}

                          {sitem?.SuListing_Filter_Searchpage_Years_Of_Operation && (
                            <p className="location">
                              <span className="mb-1 me-1">
                                <SupervisedUserCircleRoundedIcon
                                  style={{ color: "#6a1ca5", fontSize: "28px" }}
                                />
                              </span>
                              {
                                sitem.SuListing_Filter_Searchpage_Years_Of_Operation
                              }
                              {sitem.SuListing_Filter_Searchpage_Years_Of_Operation ===
                              1
                                ? " year of operation"
                                : " years of operation"}
                            </p>
                          )}
                          {sitem?.SuListing_Search_Supplier_Type_of_company && (
                            <p className="location">
                              {sitem?.SuListing_Search_Supplier_Type_of_company?.includes(
                                "Emerging",
                              ) ? (
                                <span className="mb-1 me-1">
                                  <img
                                    src={emergPlay}
                                    style={{ width: "28px" }}
                                  />
                                </span>
                              ) : (
                                <span className="mb-1 me-1">
                                  <WorkspacePremiumIcon
                                    style={{
                                      color: "#6a1ca5",
                                      fontSize: "28px",
                                    }}
                                  />
                                </span>
                              )}
                              {sitem?.SuListing_Search_Supplier_Type_of_company}
                            </p>
                          )}
                        </Card>
                        <FirstButton
                          buttonText="Request Quote"
                          className="enquire-btn dflex m-auto mb-4 dflex text-center w100"
                          style={{ display: "flex", textAlign: "center" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/supplier-term-sheet/${sitem?._id}`);
                          }}
                        />
                      </div>

                      {/* Specialties and Dosage Forms */}
                      <div className="col-md-4 p-0 w70">
                        <div className="dflex mx-4 m-2">
                          <p className="fs-14 fw-500  gpil w100">
                            <span className="fw-600">Specialties: </span>
                            {sitem?.SuListing_Search_Special_capabilities_Short_Text.join(
                              ", ",
                            )}
                          </p>
                        </div>
                        <Card className="p-3 mx-2 shadow-none">
                          <p className="location text-center  justify-content-center">
                            <span className="mb-1 me-1">
                              <SettingsSuggestRoundedIcon className="fs-20 me-4" />
                            </span>
                            Dosage forms
                          </p>

                          <Card className="card-gray-color py-3 shadow-none">
                            <div className="row">
                              {[
                                "Oral Solids",
                                "Topicals",
                                "Oral Liquids",
                                "Suppositorie",
                                "Injectable",
                                "Opthalmic",
                                "Inhalation",
                                "Otic",
                                "Nasal",
                                "Vaginal",
                                "Others",
                              ].map((item, index) => {
                                // Make comparison case-insensitive
                                const isSelected =
                                  sitem?.SuListing_Search_Dosageforms.some(
                                    (sel) =>
                                      sel.toLowerCase() === item.toLowerCase(),
                                  );

                                return (
                                  <div
                                    key={index}
                                    className=" p-0 mb-3"
                                    style={{ maxWidth: "155px" }}
                                  >
                                    <div
                                      className={
                                        isSelected
                                          ? "ppil text-center mx-3"
                                          : "opil  text-center jcsb mx-3"
                                      }
                                    >
                                      {item}
                                      <div className="mt-1">
                                        {isSelected ? (
                                          <CheckCircleIcon
                                            className="ms-2 icons-color "
                                            size={18}
                                          />
                                        ) : (
                                          <CancelOutlinedIcon
                                            className="ms-2 "
                                            size={18}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </Card>
                        </Card>
                        <Card className="p-3 mx-2 shadow-none">
                          <p className="location text-center  justify-content-center">
                            <span className="mb-1 me-1">
                              <StarsIcon className="fs-20 me-4" />
                            </span>
                            GMP accreditations
                          </p>
                          <Card className="card-gray-color py-3 shadow-none">
                            <div className="row">
                              {[
                                "USFDA",
                                "TGA",
                                "EU",
                                "Health Canada",
                                "MHRA",
                                "PICs",
                                "WHO",
                                "Others",
                              ].map((item, index) => {
                                // Make comparison case-insensitive
                                const isSelected =
                                  sitem?.SuListing_Searchpage_Detailed_GMP.some(
                                    (sel) =>
                                      sel.toLowerCase() === item.toLowerCase(),
                                  );

                                return (
                                  <div
                                    key={index}
                                    className=" p-0 mb-3"
                                    style={{ maxWidth: "155px" }}
                                  >
                                    <div
                                      className={
                                        isSelected
                                          ? "ppil text-center mx-3"
                                          : "opil  text-center jcsb mx-3"
                                      }
                                    >
                                      {item}
                                      <div className="mt-1">
                                        {isSelected ? (
                                          <CheckCircleIcon
                                            className="ms-2 icons-color "
                                            size={18}
                                          />
                                        ) : (
                                          <CancelOutlinedIcon
                                            className="ms-2 "
                                            size={18}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </Card>
                        </Card>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="w20">
              {about &&
                about.map((item, index) => (
                  <div
                    key={index}
                    className={
                      item.title === "Additional Services Required"
                        ? "ph-spcardmain2 table-gray "
                        : "ph-spcardmain2 bg-white"
                    }
                  >
                    <h2 className="fs-20 fw-600 px1">{item.title}</h2>
                    <h4 className="fs-16 fw-500 mb-3">{item?.subHead}</h4>
                    <p className="about-molecule text-justify">{item.descp}</p>
                    <FirstButton
                      className="btn my-4 mx-auto d-flex"
                      disabled={item.title === "Additional Services Required"}
                      buttonText={item?.buttonText}
                      onClick={() => navigate(item?.navi)}
                    />
                  </div>
                ))}
            </div>
          </>
        ) : (
          <div className="w80">
            <Card className="px-2 w100">
              <div className="d-flex flex-column align-items-center p-5">
                <img
                  src={noData}
                  style={{ width: "25%", height: "auto" }}
                  alt="No data found"
                />
                <p className="text-center fs-16 fw-500 light-text-color mt-3">
                  No Supplier Found
                </p>
                <p className="text-center fs-14 light-text-color">
                  Try adjusting your search criteria or filters
                </p>
              </div>
            </Card>
          </div>
        )}
      </div>
      <div className="d-flex justify-center">
        {!isLoading && count > 0 && totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={page}
            defaultPage={1}
            variant="outlined"
            onChange={handlePageChange}
            shape="rounded"
          />
        )}
      </div>
    </div>
  );
};

export default SupplierSearchPage;
